import React from "react";
import Routes from "./routes";
import AuthGuard from "@/components/AuthGuard";
import OfflineBanner from "@/components/OfflineBanner";
import { useIdleTimeout } from "@/hooks/useIdleTimeout";
import { useApplyA11yOnMount } from "@/hooks/useA11yPrefs";
import { useApplyThemeOnMount } from "@/hooks/useTheme";
import { Toaster } from "sonner";

function App() {
  // Idle timeout (auto-logout after 5 minutes of inactivity)
  useIdleTimeout();
  // MYID-D1 — apply .hc / .text-lg-mode / .no-motion classes to <html>
  // based on localStorage. Cross-tab sync via storage event.
  useApplyA11yOnMount();
  // MYID-D2 — apply .dark class to <html> based on AccountDisplayPrefs.theme
  // (DSC-1B sandman entity). 'system' watches prefers-color-scheme.
  // Cached locally so first paint matches with no flash.
  useApplyThemeOnMount();

  return (
    <AuthGuard>
      <div className="App">
        {/* MYID-D4 — sticky offline indicator (renders nothing when online) */}
        <OfflineBanner />
        {/* Sonner toast notifications (replaces CollabKareSnackbar) */}
        <Toaster position="top-center" richColors closeButton />
        <Routes />
      </div>
    </AuthGuard>
  );
}

export default App;
